// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumWorkmarkOutlinedSvg from "@ant-design/icons-svg/es/asn/MediumWorkmarkOutlined";
import AntdIcon from '../components/AntdIcon';

var MediumWorkmarkOutlined = function MediumWorkmarkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumWorkmarkOutlinedSvg
  }));
};

MediumWorkmarkOutlined.displayName = 'MediumWorkmarkOutlined';
export default React.forwardRef(MediumWorkmarkOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MediumWorkmarkOutlined.js
// module id = 1465
// module chunks = 0